import { SxProps } from "@mui/material";

export const sxMarginCardItems: SxProps = {
	marginTop: '10px',
	marginBottom: '10px'
}

export const sxPagination: SxProps = {
	width: 'auto',
	height: '32px',
	background: 'unset',
	color: 'unset',
	fontSize: 'unset',
	fontStyle: 'unset',
	fontWeight: 'unset',
	lineHeight: 'unset',
	position: 'unset',
	button: {
			fontFamily: 'UnimedSans-Bold',
			backgroundColor: '#EEE',
			color: '#5F5F5F'
	}
}

export const sxTextField: SxProps = {
	width: '60%',
	input: {
		fontFamily: 'Unimed-Sans', 
		color: '#383838', 
		fontSize: '14px', 
	},
	'@media (max-width: 899px)': {
		width: '100%'
	}
}

export const sxDivider: SxProps = {
	marginTop: '10px',
	marginBottom: '10px'
}

export const sxSubtitle: SxProps = {
	color: '#4C4C4C',
	fontFamily: 'Unimed-Sans',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: '400',
	lineHeight: '24px',
	marginBottom: '25px',
	maxWidth: '700px'
}

export const sxButtonVoltar: SxProps = {
	textDecoration: 'underline',
	textTransform: 'none',
	fontFamily: 'Unimed-Sans',
	fontWeight: 600,
	padding: 0,
	'&:hover': {
		color: '#164029',
	},
	color: '#383838'
}